// extracted by mini-css-extract-plugin
export var heroImage = "_dl-1";
export var modal = "_dl-0";